import { Stack, Typography } from "@mui/material";
import type { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import { getActiveLayer } from "../../../../store/utils/getActiveLayer.ts";
import SourceColumnLinks from "./SourceColumnLinks.tsx";

interface Props {
  configuration: DrillDownPage;
  title: string;
}

export default function ExtensionLedgerTitle({ configuration, title }: Props) {
  const activeLayer = getActiveLayer(configuration);
  const measure = activeLayer.measure;
  const aggregationName = measure?.config.customLabel || measure?.config.systemLabel || measure?.meta.caption;
  const cellValue = activeLayer.formattedValue ?? activeLayer.cell.formattedValue;
  const sourceFields = activeLayer.info?.combined.valueTargetFields ?? [];
  const hasSubtitle = !!cellValue || sourceFields.length > 0;
  const separator = cellValue && sourceFields.length > 0 ? " · " : "";

  return (
    <Stack sx={{ py: 1.25, gap: 0.25 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {title} &bull; {aggregationName}
      </Typography>
      <Stack direction="row" sx={{ gap: 1, alignItems: "center" }}>
        {hasSubtitle && (
          <Typography variant="body2" color="textSecondary">
            {cellValue}
            {separator}
            <SourceColumnLinks fields={sourceFields} />
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
